var map = {
	"./certificate_image.png": 1510,
	"./complated.png": 1511,
	"./download_icon.png": 791,
	"./facebook_icon.png": 792,
	"./linkedin_icon.png": 793,
	"./logo.png": 1512,
	"./pending.png": 1513,
	"./score_icon.png": 1514,
	"./training.png": 1515
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1509;